const Theme = {
  logo_image_url: 'ecomuseestnazaire.png',
  logo_height: 100,
  token_url: 'ecomuseestnazaire.png',
  number_hidden: true,

  button_color: '#fa130c',

  text_font: `'Helvetica', sans-serif`,
  text_color: 'black',
  title_font: `'Helvetica', sans-serif`,
}

export default Theme
